import * as React from 'react';
interface ContextType {
  iStage: number,
  tabToastOpen: (text: string) => void,
}
const Default: ContextType = {
  iStage: 0,
  tabToastOpen: () => '',
}
const StageDefault = React.createContext(Default);

export {
  StageDefault,
}